export const breadcrumbNameMap = {
  ferramentas: "Ferramentas",
  "operacao-terceira": "Gestão terceira",
  "motivos-atraso": "Motivos de atraso",
  "cobertura-estoque": "Cobertura de estoque",
  anexos: "Anexos",
  "admin-stone-entrega": "Admin Stone Entrega",
  "consulta-doa": "Consulta de report DOA",
  "report-doa-terceira": "Reportar DOA",
  senninha: "Senninha",
  cockpit: "Cockpit Distrital",
  "gestao-de-equipe": "Gestão de Equipe",
  "controle-de-roteirizacao": "Controle de Roteirização",
  "justificativa-de-improdutividade": "Justificativa de Improdutividade"
};

export const breadcrumbRouteMap = {
  "/ferramentas": "/",
  "/lmp": "/",
  "/lmp/senninha": "/senninha",
};

export const breadcrumbBlackList = ["lmp"];
